import { CSSResultGroup, html, LitElement, PropertyValues } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { style } from './list.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'
import { CSEListItem } from 'elements/list-item/list-item.js'


@customElement('cse-list')
export class CSEList extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, style]

  @property({ type: Boolean })
  inline = false

  @property({ type: Boolean })
  divider = false

  @query('slot')
  private defaultSlot!: HTMLSlotElement

  protected override updated(changedProperties: PropertyValues): void {
    super.updated(changedProperties)

    const assignedNodesDefault = this.defaultSlot.assignedNodes({ flatten: true })
    const assignedListItems = assignedNodesDefault.map(this.findListItem).filter(this.isListItem)

    if (assignedListItems.length > 0) {
      assignedListItems.forEach((listItem) => {
        const nextSibling = listItem.nextElementSibling
        if (nextSibling && nextSibling.tagName === 'CSE-DIVIDER') {
          nextSibling.remove()
        }

        if (this.divider && !(this.inline && listItem === listItem.parentElement?.lastElementChild)) {
          listItem.insertAdjacentHTML(
            'afterend',
            `<cse-divider orientation="${this.inline ? 'vertical' : 'horizontal'}"></cse-divider>`
          )
        }
      })
    }
  }

  private findListItem(node: Node): CSEListItem | null {
    const selector = 'cse-list-item'
    return node instanceof HTMLElement ? node.closest(selector) ?? node.querySelector(selector) : null
  }

  private isListItem(listItem: CSEListItem | null): listItem is CSEListItem {
    return listItem !== null
  }

  override render() {
    return html`
      <ul class=${classMap({
        'cse-list': true,
        'inline': this.inline,
        'has-divider': this.divider,
      })}>
        <slot></slot>
      </ul>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-list': CSEList
  }
}
